import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BosniaAndHerzegovinaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14361'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14361)'>
				<rect
					width='20'
					height='14'
					fill='#0B36B2'
				/>
				<g filter='url(#filter0_d_2332_14361)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M16.1914 14V0H6.19141L16.1914 14Z'
						fill='#FFD045'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3801 13.0666L11.7067 13.2599L11.9039 12.6L11.7067 11.94L12.3801 12.1333L13.0536 11.94L12.8563 12.6L13.0536 13.2599L12.3801 13.0666Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4758 10.2667L9.80238 10.46L9.99963 9.80003L9.80238 9.14007L10.4758 9.33337L11.1493 9.14007L10.952 9.80003L11.1493 10.46L10.4758 10.2667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57152 7.46665L7.89809 7.65995L8.09533 6.99998L7.89809 6.34002L8.57152 6.53332L9.24496 6.34002L9.04771 6.99998L9.24496 7.65995L8.57152 7.46665Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66722 4.66672L5.99379 4.86002L6.19103 4.20006L5.99379 3.54009L6.66722 3.73339L7.34066 3.54009L7.14342 4.20006L7.34066 4.86002L6.66722 4.66672Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76097 1.86667L4.08754 2.05997L4.28478 1.40001L4.08754 0.740042L4.76097 0.933342L5.43441 0.740042L5.23717 1.40001L5.43441 2.05997L4.76097 1.86667Z'
					fill='white'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14361'
					x='6.19141'
					y='0'
					width='10'
					height='14'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14361'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14361'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default BosniaAndHerzegovinaFlagIcon;
